import * as React from 'react'
import './description.css'


export default class Description extends React.Component<any, any>{

    render(){
        const description = this.props.description;

        if(description){
            return <small className="form-text text-muted description">{ description }</small>
        }else{
            return null;
        }

    }

}


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/common/components/description.tsx